import { Address } from '../util/address.model';
import { ChurchUnit } from '../ecclesiastical/church-unit.model';

export class Student {
    iNumber: string;
    name: string;
    emailAddress: string;
    privacyMessage: string;
    byuIdahoPhotoBase64: string;
    address: Address;
    homeUnit: ChurchUnit;
}
